export default __webpack_public_path__ + "static/media/Sail.a9dfd34f.mp3";